// function to convert file to blob declared here
export const convertFileToBlob = (file: File): Promise<Blob> => {
  return new Promise((resolve, reject) => {
    try {
      if (file.name.length > 100) {
        reject(
          new Error(
            'Invalid file name! File name must be under 100 characters.'
          )
        );
      }

      const reader = new FileReader();

      reader.onerror = () => {
        reject(new Error('Invalid document file!!'));
      };

      reader.onload = (e) => {
        if (e.target?.result) {
          const arrayBuffer = e.target.result as ArrayBuffer;

          const blob = new Blob([arrayBuffer], { type: file.type });

          resolve(blob);
        } else {
          reject(new Error('Invalid document file!!'));
        }
      };

      reader.readAsArrayBuffer(file);
    } catch (error) {}
  });
};
